export const validateEmail = (email) => (/\S+@\S+\.\S+/).test(email);
